<template>
	<div class="xhorse-home">
		<div class="pos-list" :style="{minHeight: tagHeight.posList}">
			<x-header :path="$path"
					  :backColor="backColor"
					  :textColor="textColor"
					  :activeSideIndex="activeIndex.side"
					  :activeTopIndex="activeIndex.top"
					  @go="activeTo"
			></x-header>
			<div class="post-con" :style="{minHeight: tagHeight.posCon}">
				<x-join-tab
				v-if="activeName!=4"
				:activeName="activeName"
				:activeScope="activeScope"
				@height="setHeight"
				@find="showDetail"
				@do="renderList"></x-join-tab>
				<div class="list-con" :style="{minHeight: tagHeight.listCon}">
					<x-bread-tab v-if="activeName!=4"
								 :activeName="activeName"
								 :activeScope="activeScope"
								 :activeType="activeType"
								 @find="showDetail"
								 @do="renderList"></x-bread-tab>
					<x-join-list v-if="activeName==1"
								 :activeScope="activeScope"
								 :activeType="activeType"
								 @find="showDetail"
								 @height="setHeight"
					></x-join-list>
					<x-join-detail v-if="activeName==2"
								   @go="activeTo"
								   :tagHeight="tagHeight"
								   :activePosInfo="activePosInfo"></x-join-detail>
					<x-join-submit v-if="activeName==3" :activePosId="activePosId"
								   :activePosInfo="activePosInfo" @go="activeTo"></x-join-submit>
					<x-join-res v-if="activeName==4" @go="activeTo"></x-join-res>
				</div>
			</div>
		</div>
		<x-footer></x-footer>
		<x-home :backVisible="backVisible" :backStyle="backStyle"></x-home>
	</div>
</template>

<script>
    import xHeader from '@/components/zh-cn/header.vue'
    import xJoinTab from '@/components/zh-cn/join/join-tab.vue'
    import xBreadTab from '@/components/zh-cn/join/join-bread.vue'
    import xJoinList from '@/components/zh-cn/join/join-list.vue'
    import xJoinDetail from '@/components/zh-cn/join/join-detail.vue'
    import xJoinSubmit from '@/components/zh-cn/join/join-submit.vue'
    import xJoinRes from '@/components/zh-cn/join/join-res.vue'

    import coreLib from '@/lib/common'
    export default {
        components: {
            xHeader: xHeader,
            xFooter: () => import('@/components/zh-cn/footer'),
            xHome: () => import('@/components/zh-cn/home'),
            xJoinTab: xJoinTab,
            xBreadTab: xBreadTab,
            xJoinList: xJoinList,
            xJoinDetail: xJoinDetail,
            xJoinSubmit: xJoinSubmit,
            xJoinRes: xJoinRes,

        },
        data() {
            const _this = this;
            return {
                activeName: 1,
                activeScope: 1,
                activeType: 0,
                activePosId: 0,
                activePosInfo: {},
                tagHeight: {
                    posList: '88.5625rem',
                    posCon: '84.0625rem',
                    listCon: '74rem'
                },
                textColor: '#2A2E2E',
                backColor: '#FFFFFF',
                page: {
                    currentPage: 1,
                    pageSize: 1,
                    pagerCount: 7,
                    total: 1,
                },
                activeIndex: {
                    top: [],
                    side: []
                },
                backVisible: false,
                backStyle: {
                    bottom: '4rem'
                }
            }
        },
        watch: {
            '$route': {
                handler: 'renderView',
                deep: true
            },
        },
        methods: {
            showDetail(params){
                const _this = this;
                if (params.activeName) {
                    _this.activeName = parseInt(params.activeName)
                }
                if (params.activeScope) {
                    _this.activeScope = parseInt(params.activeScope)
                }
                if (params.activePosInfo) {
                    _this.activePosInfo = params.activePosInfo
                }
            },
            renderList(params){
                const _this = this;
                const componentInfo = _this.$RegistedName;
                if (params.type == 'scope') {
                    _this.activeScope = params.val;
                }
                if (params.type == 'type') {
                    _this.activeType = params.val
                }
                _this.tagHeight.posList = '88.5625rem';
                _this.tagHeight.posCon = '84.0625rem';
                _this.tagHeight.listCon = '74rem';
            },
            onPageChange: function () {

            },
            whichLang: function (path) {
                return path == 'zh-cn';
            },
            renderView: function () {
                const _this = this;
                let params = _this.$route.params;
                if (params.activeName) {
                    _this.activeName = parseInt(params.activeName)
                }
                if (params.ActiveScope) {
                    _this.activeScope = parseInt(params.ActiveScope)
                }
                if (params.activePosInfo) {
                    _this.activePosInfo = params.activePosInfo
                }
            },
            activeTo(params){
                const _this = this;
                const componentInfo = _this.$RegistedName;
                const isMobile = coreLib._isMobile();
                const dateTime = (new Date()).getTime();
                if (params.type == 'top') {
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeIndex.top = fullPath;
                    _this.activeIndex.side = fullPath.slice(-1);
                    _this.$router.push({path: componentInfo[fullPath[0]].componentName, params: {date: dateTime}})
                } else if (params.type == 'side') {
                    _this.activeIndex.side = params.val
                } else if (params.type == 'apply') {
                    _this.tagHeight['posList'] = '77.375rem';
                    _this.tagHeight['posCon'] = '72.875rem';
                    _this.tagHeight['listCon'] = '62.8125rem';
                    _this.activeName = params.val.activeName;
                    _this.activePosId = params.val.activePosId;
                } else if (params.type == 'notice') {
                    _this.activeName = params.val.activeName;
                    _this.activePosId = 0;
                    _this.tagHeight['posList'] = '70.5625rem';
                    _this.tagHeight['posCon'] = '66.0625rem';
                    _this.tagHeight['listCon'] = '66.0625rem';
                } else if (params.type == 'back') {
                    _this.activeName = params.val.activeName;
                    _this.activePosId = 0;
                    if (params.val) {
                        _this.tagHeight.posList = params.val.posListheight;
                        _this.tagHeight.posCon = params.val.posConheight;
                        _this.tagHeight.listCon = params.val.listConheight;
                    }
                }
            },
            setHeight(params){
                const _this = this;
                if (params.type == 'screen') {
                    _this.tagHeight.posList = params.val.posListheight;
                    _this.tagHeight.posCon = params.val.posConheight;
                    _this.tagHeight.listCon = params.val.listConheight;
                }
            },
            onAboutScroll(){
                const _this = this;
                const xheader = document.getElementById('x-header').getBoundingClientRect();
                const xfooter = document.getElementById('x-wrap-footer').getBoundingClientRect();
                const viewHeight = window.screen.availHeight;
                const viewWidth = window.screen.availWidth;
                //console.log("apply[xfooter]", xfooter)
                try {
                    if (xheader.top < _this.$visibleHomeTop) {
                        _this.backVisible = true;
                        if ((xfooter.top / 16) <= (viewHeight / 16)) {
                            const realBottomEm =
                            ((viewHeight - xfooter.top) / 16) < 30 ?
                            (30 + 0.8125 + 'rem') : (((viewHeight - xfooter.top) / 16) + 0.8125 + 'rem');
                            const realBottomPx = (viewHeight - xfooter.top) + 'px';
                            _this.backStyle.bottom = viewWidth > 1280 ? realBottomPx : realBottomEm;
                        } else {
                            _this.backStyle.bottom = '3rem';
                        }
                    } else {
                        _this.backVisible = false;
                    }
                } catch (err) {
                    //console.log(err)
                }

            },
        },
        created() {
            const _this = this;
            _this.renderView()
        },
        mounted() {
            const _this = this;
            // 监听滚动事件
            window.addEventListener('scroll', _this.onAboutScroll, true);
        },
        destroyed() {
            const _this = this;
            window.removeEventListener('scroll', _this.onAboutScroll, true);
        },
        beforeRouteLeave (to, from, next) {
            const _this = this;
            window.removeEventListener('scroll', _this.onAboutScroll);
            next(true)
        }
    }
</script>

<style scoped>
	@import "../../assets/css/apply.css";
</style>






// WEBPACK FOOTER //
// src/components/zh-cn/apply.vue